<script setup>
import SaveCallbackRequestAction from "@frontJs/components/actions/SaveCallbackRequestAction.vue";
import ToggleCallbackRequestProcessedAtAction from "@frontJs/components/actions/ToggleCallbackRequestProcessedAtAction.vue";
import { CheckIcon, PencilIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row, callback } = defineProps({
  row: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: false,
  },
});
</script>

<template>
  <div class="flex h-full items-center gap-2 p-4">
    <ToggleCallbackRequestProcessedAtAction
      :callback-request="row.original"
      :callback="
        () => {
          toast.success(t('toast.successfullySaved'), {
            position: 'top-right',
          });

          if (callback) {
            callback();
          }
        }
      "
    >
      <template #button="{ action, loading }">
        <ActionButton
          size="small"
          class="size-8"
          :title="
            row.original.processedAt === null
              ? t('button.process')
              : t('button.unprocess')
          "
          type="secondary"
          :callback="() => action()"
          :icon="row.original.processedAt === null ? CheckIcon : XMarkIcon"
          :loading="loading"
        />
      </template>
    </ToggleCallbackRequestProcessedAtAction>

    <SaveCallbackRequestAction
      :callback-request="row.original"
      :callback="
        () => {
          toast.success(t('toast.successfullySaved'), {
            position: 'top-right',
          });

          if (callback) {
            callback();
          }
        }
      "
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          type="primary"
          class="size-8"
          :callback="() => setIsOpen(true)"
          :title="t('button.edit')"
          :icon="PencilIcon"
        />
      </template>
    </SaveCallbackRequestAction>
  </div>
</template>
